import { Button, Container, Grid, InputLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import SalesAreaConfig from "../components/Config/SalesArea";
import { InstyleButton } from "../components/Page/Page";
import InstyleSwitch from "../components/Switch/InstyleSwitch";
import { getConfig, load } from "../store/slices/configSlice";
import { load as loadBookings, getAllBookings } from "../store/slices/bookingSlice";
import { load as loadSalesAreas } from "../store/slices/salesAreaSlice";
import { configService } from "../services";
import MagicDial from "../components/Config/MagicDial";

export const ConfigPath = "/config";

function Config() {
  const [saveDisabled, setSaveDisabled] = React.useState(false);
  const [script, setScript] = React.useState('')
  const [rebuildDialogOpen, setRebuildDialogOpen] = React.useState(false);
  const [rebuildInProgress, setRebuildInProgress] = React.useState(false);
  const dispatch = useDispatch();
  const config = useSelector(getConfig);
  const bookings = useSelector(getAllBookings);
  let isError = false;
  let errorMessage = "";

  useEffect(() => {
    if (config?.Script) {
      setScript(config.Script);
    }
  }, [config])

  const handleToggle = (isChecked) => {
    let val = isChecked ? 1 : 2;
    let newConfig = {...config, DialMode: val}
    dispatch(load(newConfig))
  }

  const saveConfig = () => {
    setSaveDisabled(true);
    configService.saveConfig(config).then(() => {
      //post the config and on success refresh the data here
      updateConfig();
    }).catch(err => {
      isError = true;
      errorMessage = err;
      setSaveDisabled(false);
    })
  }

  const saveScript = () => {
    setSaveDisabled(true);
    var newConf = JSON.parse(JSON.stringify(config))
    newConf.Script = script;
    configService.saveScript(newConf).then(() => {
      //post the config and on success refresh the data here
      updateConfig();
    }).catch(err => {
      isError = true;
      errorMessage = err;
      setSaveDisabled(false);
    })
  }

  const updateConfig = () => {
    configService.getConfig().then((config) => {
        if (config.Success) {
          //set the config to store
          dispatch(load(config.Data.Config));
          //save booking info
          dispatch(loadBookings(config.Data.BookingInfo));
          //process sales areas and put them in store
          let saData = [];
          Object.keys(config.Data.AvailableSalesAreas).map(k => {
            saData.push({
              ID: config.Data.AvailableSalesAreas[k],
              Label: k
            });
          });
          dispatch(loadSalesAreas(saData));
        } else {
          isError = true;
          errorMessage = config.Message;
        }
        setSaveDisabled(false);
      })
  }

  const handleScriptChange = (e) => {
    setScript(e.target.value)
  }

  const handleRebuildCallList = () => {
    setRebuildInProgress(true);
    configService.rebuildCallList().then((response) => {
      setRebuildDialogOpen(false);
      setRebuildInProgress(false);
      alert(response.Message || 'Rebuild started');
    }).catch(err => {
      setRebuildInProgress(false);
      alert('Error: ' + err);
    });
  }

  if (!config.SalesArea) {
    updateConfig();
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <InstyleSwitch LeftLabel={'Sales Area'} RightLabel={'Available Slots'} checked={config.DialMode == 1} onToggle={handleToggle} />
      </Grid>
      <Grid item xs={12} style={{justifyContent: "center", display: "flex"}}>
        <InstyleButton onClick={saveConfig} disabled={saveDisabled}>Save</InstyleButton>
      </Grid>
      <Grid container style={{padding: "10px", textAlign: "center"}}>
        {
          config.DialMode == 2 && <SalesAreaConfig config={config} />
        }
        {
          config.DialMode == 1 && <MagicDial config={config} bookings={bookings}/>
        }
      </Grid>
      <Grid container spacing={2}>
        <Grid item lg={12} style={{margin: '20px'}}>
          <InputLabel>Script</InputLabel>
          <textarea
            style={{width: '100%', height: '400px'}}
            rows={40}
            value={script}
            onChange={handleScriptChange}
          ></textarea>
          <InstyleButton onClick={saveScript}>Save Script</InstyleButton>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{marginTop: '40px', borderTop: '1px solid #ccc', paddingTop: '20px'}}>
        <Grid item lg={12} style={{margin: '20px'}}>
          <InputLabel style={{color: '#d32f2f'}}>Admin Actions</InputLabel>
          <Button
            variant="contained"
            style={{backgroundColor: '#d32f2f', color: 'white', marginTop: '10px'}}
            onClick={() => setRebuildDialogOpen(true)}
          >
            Rebuild Call List
          </Button>
        </Grid>
      </Grid>

      <Dialog open={rebuildDialogOpen} onClose={() => setRebuildDialogOpen(false)}>
        <DialogTitle>Rebuild Call List</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will clear the entire call list and repopulate it from Pipedrive.
            This operation may take several minutes. Are you sure you want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRebuildDialogOpen(false)} disabled={rebuildInProgress}>
            Cancel
          </Button>
          <Button
            onClick={handleRebuildCallList}
            color="secondary"
            disabled={rebuildInProgress}
          >
            {rebuildInProgress ? 'Rebuilding...' : 'Rebuild'}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>

  );
}

export default Config;
